export default {
    'LOGIN': 'login',
    'INTL_DATA': 'intl-data',
    'PATIENT_DATA': "patient-data",
    'SAVE_PATIENT_DATA': "save-patient-data",
    'CANCEL_PATIENT_DATA': "cancel-patient-data",
    'PATIENT_APP_VERSION': "patient-app-version"
}